export default "__VITE_ASSET__BVQvcDvx__"